import './Header.scss';
class Header {
    constructor( node ) {
        this.node = node;
    }
    init() {
        let t = this;

        
        // -- header state -- //

            t.node.insertAdjacentHTML('beforebegin','<div class="Header__line Header__line--after"></div>');
            let currentPosition = window.scrollY;
            let headerHeight = t.node.offsetHeight;
            window.addEventListener('resize', function() {
                headerHeight = t.node.offsetHeight;
            });
            window.addEventListener('scroll', () => {
                // if( !nav.classList.contains('active') ) {
                    if( window.scrollY > headerHeight ) {
                        if( currentPosition < window.scrollY ) { // scroll down
                            t.node.setAttribute('data-state','hide');
                        } else { // scroll top
                            t.node.setAttribute('data-state','show');
                        }
                    } else {
                        t.node.setAttribute('data-state','show');
                    }
                // }
                currentPosition = window.scrollY;
            });
        
        // -- END -- //


        // -- update date -- //
            let lang = 'pl-PL';
            if( document.querySelector('html').hasAttribute('lang') ) {
                lang = document.querySelector('html').getAttribute('lang');
            }
            
            let dateStart = t.node.querySelector('.calendar__date .date__start');
            let dateEnd = t.node.querySelector('.calendar__date .date__end');

            let date = new Date();
            let day = new Intl.DateTimeFormat( lang , { day: 'numeric' }).format(date);
            let month = new Intl.DateTimeFormat( lang , { month: 'short' }).format(date);
            dateStart.textContent = day + ' ' + month;

            let date3 = new Date(date.setDate(date.getDate() + 3 ));
            let day3 = new Intl.DateTimeFormat( lang , { day: 'numeric' }).format(date3);
            dateEnd.textContent = day3 + ' ' + month;
        // -- END -- //

    }
}
JSModules['Header'] = Header;
export default Header;